export interface INotificationService {
    showToast(message: string): void;
    showAlertWithOk(message: string): void;
    showToastWithMentionedDelay(message: string, delayInMilliSeconds: number) : void;
}

export class NotificationService implements INotificationService {
    static $inject: string[] = ['$mdToast', '$mdDialog'];

    constructor(private $mdToast: ng.material.IToastService,
        private $mdDialog: ng.material.IDialogService) {
    }

    showToast(message: string): void {
        this.$mdToast.show(
            this.$mdToast.simple()
                .textContent(message)
                .position('bottom')
                .hideDelay(3000));
    }

    showToastWithMentionedDelay(message: string,delayInMilliSeconds : number): void {
        this.$mdToast.show(
            this.$mdToast.simple()
                .textContent(message)
                .position('bottom')
                .hideDelay(delayInMilliSeconds));
    }

    showAlertWithOk(message: string): void {
        this.$mdDialog.show(this.$mdDialog.alert()
            .textContent(message)
            .ok('OK'));
    }
}


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/core/notificationService.ts
 **/